const defPublic = {
    defaultAvatar:'https://img-joyreader.wawayaya.com/avatar_icon/default_boy.jpg',
    headerLink1:'#',
    headerLink2:'https://book.wawayaya.com',
    headerLink3:'https://joyreader.wawayaya.com',
    groupReadingChartApiPath:['rw','rcb','rb','rt'],
    groupFollowReadingChartApiPath0:'sentences',
    groupFollowReadingChartApiPath1:'score',
    groupFollowReadingChartApiPath2:'lang',
    groupRankTypeApiPath0:'bookworm',
    groupRankTypeApiPath1:'insistence',
    groupRankTypeApiPath2:'lwords',
    groupRankTypeApiPath3:'reval',
    groupRankTypeApiPath4:'mb/listening/p',
    groupRankTypeApiPath5:'qgame',
    selectScopeApiPath_s:'schools',
    selectScopeApiPath_c:'classes',
    selectScopeApiPath_g:'groups',
    selectScopeApiPath_u:'cg/students',
    searchScopeApiPath_s:'search/schools',
    searchScopeApiPath_c:'search/classes',
    searchScopeApiPath_g:'search/groups',
    searchScopeApiPath_u:'cg/search/students',
}

export default {
    ...defPublic,
    netBasePath: 'https://api3-joyreader.wawayaya.com',
    weexScanLoginPath:'https://d.wawayaya.com/s/?_wx_tpl=http://weex.wawayaya.com/pro/scanLogin/app/pages/login/entry.js',
    weexPayPath:'http://d.wawayaya.com/?_wx_tpl=https://weex.wawayaya.com/pro/payPages/app/pages/rt/entry.js',
    de:''
}


/*export default {
    ...defPublic,
    netBasePath: 'https://testapi3-joyreader.wawayaya.com',
    // weexScanLoginPath:'http://192.168.0.136:8082?_wx_tpl=http://192.168.0.136:8082/dist/pages/login/entry.js',
    weexScanLoginPath:'https://d.wawayaya.com/s/?_wx_tpl=https://testweex.wawayaya.com/test/scanLogin/app/pages/login/entry.js',
    weexPayPath:'http://d.wawayaya.com/?_wx_tpl=https://weex.wawayaya.com/pro/payPages/app/pages/rt/entry.js',
    de:''
}*/


